/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppRequestsDeliveryRouteImport } from './routes/_app/requests/delivery'
import { Route as AppRequestsNewRouteImport } from './routes/_app/requests/new'
import { Route as AppRequestsQueueRouteImport } from './routes/_app/requests/queue'
import { Route as AppRequestsReviewRouteImport } from './routes/_app/requests/review'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsDeliveryRoute = AppRequestsDeliveryRouteImport.update({
  id: '/requests/delivery',
  path: '/requests/delivery',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsNewRoute = AppRequestsNewRouteImport.update({
  id: '/requests/new',
  path: '/requests/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsQueueRoute = AppRequestsQueueRouteImport.update({
  id: '/requests/queue',
  path: '/requests/queue',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsReviewRoute = AppRequestsReviewRouteImport.update({
  id: '/requests/review',
  path: '/requests/review',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/requests/delivery': typeof AppRequestsDeliveryRoute
  '/requests/new': typeof AppRequestsNewRoute
  '/requests/queue': typeof AppRequestsQueueRoute
  '/requests/review': typeof AppRequestsReviewRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/': typeof AppIndexRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/requests/delivery': typeof AppRequestsDeliveryRoute
  '/requests/new': typeof AppRequestsNewRoute
  '/requests/queue': typeof AppRequestsQueueRoute
  '/requests/review': typeof AppRequestsReviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/requests/delivery': typeof AppRequestsDeliveryRoute
  '/_app/requests/new': typeof AppRequestsNewRoute
  '/_app/requests/queue': typeof AppRequestsQueueRoute
  '/_app/requests/review': typeof AppRequestsReviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sso-callback'
    | '/admin/users'
    | '/requests/delivery'
    | '/requests/new'
    | '/requests/queue'
    | '/requests/review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/sso-callback'
    | '/'
    | '/admin/users'
    | '/requests/delivery'
    | '/requests/new'
    | '/requests/queue'
    | '/requests/review'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/sso-callback'
    | '/_app/'
    | '/_app/admin/users'
    | '/_app/requests/delivery'
    | '/_app/requests/new'
    | '/_app/requests/queue'
    | '/_app/requests/review'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests/delivery': {
      id: '/_app/requests/delivery'
      path: '/requests/delivery'
      fullPath: '/requests/delivery'
      preLoaderRoute: typeof AppRequestsDeliveryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests/new': {
      id: '/_app/requests/new'
      path: '/requests/new'
      fullPath: '/requests/new'
      preLoaderRoute: typeof AppRequestsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests/queue': {
      id: '/_app/requests/queue'
      path: '/requests/queue'
      fullPath: '/requests/queue'
      preLoaderRoute: typeof AppRequestsQueueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests/review': {
      id: '/_app/requests/review'
      path: '/requests/review'
      fullPath: '/requests/review'
      preLoaderRoute: typeof AppRequestsReviewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppRequestsDeliveryRoute: typeof AppRequestsDeliveryRoute
  AppRequestsNewRoute: typeof AppRequestsNewRoute
  AppRequestsQueueRoute: typeof AppRequestsQueueRoute
  AppRequestsReviewRoute: typeof AppRequestsReviewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppRequestsDeliveryRoute: AppRequestsDeliveryRoute,
  AppRequestsNewRoute: AppRequestsNewRoute,
  AppRequestsQueueRoute: AppRequestsQueueRoute,
  AppRequestsReviewRoute: AppRequestsReviewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SsoCallbackRoute: SsoCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
